import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box } from "@mui/system";
import RemoveIcon from "@mui/icons-material/Remove";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import { CircularProgress } from "@mui/material";
import ProfileContext from "../../context/ProfileContext";
import useAuth from "../../hooks/useAuth";

function SectionComponentForOtherDept({
  section,
  courseCode,
  getCourseGroups,
}) {
  let { assignstaff, deAssignStaff, getStaffs, alignStaffData, showSection } =
    React.useContext(CourseAssignmentContext);
  let [requestedGroups, setRequestedGroups] = React.useState([]);
  let [loading, setLoading] = React.useState(false);

  let { staffs, assign, setAssigned } = React.useContext(
    CourseAssignmentContext
  );

  let {state}=React.useContext(ProfileContext)
  let {user}=useAuth()

  React.useEffect(() => {
    getCourseGroups(courseCode);
  }, [showSection]);

  function assignBgColor(load, exp, max) {
    let color = "black";
    if (load < exp) {
      color = "gray";
    } else if (load >= exp && load < max) {
      color = "green";
    } else if (load >= max) {
      color = "red";
    }

    return color;
  }

  function getstaffLoadforCourse(sID) {
    let load = 0;

    for (let i = 0; i < staffs.length; i++) {
      if (staffs[i].id === sID) {
        load = staffs[i].TOTAL_LEH;
      }
    }

    return load;
  }

  async function staffDroppped(e, gId, gLEH) {
    e.preventDefault();
    let stafftoassign = e.dataTransfer.getData("staffId");
    setLoading(true);
    let assigned = await assignstaff(gId, courseCode, stafftoassign, gLEH);
    if (assigned === true) {
      setAssigned({});
      getStaffs(true);
      alignStaffData();
      setLoading(false);
      getCourseGroups(courseCode);
    } else {
      setLoading(false);
      alert("error");
    }
  }

  async function onRemove(gId, sId, LoadLeh) {
    setLoading(true);
    let removed = await deAssignStaff(gId, courseCode, sId, LoadLeh);
    if (removed === true) {
      getStaffs(true);

      setLoading(false);
      getCourseGroups(courseCode);
    } else {
      setLoading(false);
      alert("error");
    }
  }

  return (
    <React.Fragment>
      <Box
        sx={{
          color: "brown",
          marginLeft: 3,
        }}
      >
        Section {section.title}
      </Box>

      <TableContainer
        sx={{
          border: 2,
          borderColor: "#cd853f",
          minWidth: "90%",
          width: "95%",
          marginBottom: 4,
        }}
      >
        <Table
          sx={{ minWidth: "90%", width: "95%", border: 0 }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", fontSize: 16 }}>
                Group
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold", fontSize: 16 }}>
                Load
              </TableCell>
              <TableCell
                align="center"
                sx={{ fontWeight: "bold", fontSize: 16 }}
              >
                Allocated Staff
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {section.Groups !== null &&
              section.Groups.map((group, index) => (
                <TableRow key={index} sx={{ border: 0 }}>
                  <TableCell component="th" scope="row">
                    {group.type}
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{ fontWeight: "bold", fontSize: 16 }}
                  >
                    {group.Load_leh}
                  </TableCell>
                  <TableCell align="center">
                    {group.assignedstaff !== null && (
                      <div className="section-group-allocated-staff">
                        <Box
                          sx={{
                            marginTop: 1,
                            border: 1,
                            paddingTop: 1,
                            paddingBottom: 0.5,
                            paddingLeft: 1,
                            paddingRight: 1,
                            borderRadius: 2,
                            transform: "scale(0.7)",
                            backgroundColor: "white",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            onRemove(
                              group.id,
                              group.assignedstaff.id,
                              group.Load_leh
                            );
                          }}
                        >
                          <RemoveIcon
                            sx={{ fontSize: 20, fontWeight: "bold" }}
                          />
                        </Box>
                        <Box
                          component={Avatar}
                          sx={{
                            marginRight: 1.5,
                            borderRadius: 40,
                            width: 50,
                            height: 50,
                          }}
                          src={state.host+group.assignedstaff.User?.profile_pic.slice(1,)+`?token=${user?.accessToken}`}

                        ></Box>
                        <Box
                          sx={{
                            marginTop: 1,
                            marginLeft: -3,
                            fontWeight: 700,
                          }}
                        >
                          {group.assignedstaff.User !== null &&
                            group.assignedstaff.User.first_name}
                        </Box>

                        <Box
                          sx={{
                            marginTop: 1,

                            fontWeight: 900,
                            color: "white",
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              padding: "3px 5px",
                              borderRadius: "5px",
                              backgroundColor: assignBgColor(
                                getstaffLoadforCourse(group.assignedstaff.id),
                                group.assignedstaff.Status.expected_load,
                                group.assignedstaff.Status.max_load
                              ),
                            }}
                          >
                            {getstaffLoadforCourse(group.assignedstaff.id)}
                          </div>
                        </Box>
                      </div>
                    )}

                    {group.assignedstaff === null && (
                      <div
                        className="dropSection"
                        droppable={"true"}
                        onDragOver={(e) => {
                          e.preventDefault();
                        }}
                        onDrop={(e) => {
                          staffDroppped(e, group.id, group.Load_leh);
                        }}
                      >
                        <span>Drop Selection Here</span>
                        <PersonAddAlt1OutlinedIcon
                          sx={{
                            marginLeft: 2,
                            transform: "scale(1.3)",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setAssigned({
                              ...assign,
                              courseCode,
                              group_id: group.id,
                              Load: group.Load_leh,
                            });
                          }}
                        />
                        {loading === true && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CircularProgress />
                          </Box>
                        )}
                      </div>
                    )}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
}

export default SectionComponentForOtherDept;
